import { defineStore } from "pinia";
import { useRest, useStoreCompat } from "@/composables/index";
import { ref, computed } from "vue";

export const useEstadisticasJudicialStore = defineStore("estadísticasJudiciales", () => {
  const rest = useRest();
  const store = useStoreCompat();

  const loadingJudicial = ref(false);
  const loadingItems = ref([]);
  const baseUrl = process.env.VUE_APP_BACKEND_ENVIRONMENT;
  const typeStates = ref([]);
  const totalsTypesStates = ref([]);

  const categoriesLabels = ref([]);
  const seriesData = ref([]);
  const allCategories = computed(() => store.state.siis.categoriasDeposito);

  const buildStats = async () => {
    const totals = await Promise.all(
      allCategories.value.map(async (categorie) => {
        const { data } = await rest.get(
          `${baseUrl}/deposito?${buildSearchParams("CategoriaID", categorie.CategoriaID)}`
        );
        return {
          ...categorie,
          totals: +data.data[0]?.total || 0,
        };
      })
    );

    categoriesLabels.value = totals.map((t) => t.Nombre);
    seriesData.value = [
      {
        name: "Categoría",
        data: totals.map((t) => t.totals),
      },
    ];
  };

  const buildSearchParams = (field, id) => {
    const search = JSON.stringify({
      [field]: [{ operator: "=", value: id }],
    });
    let params;

    if (field === "exp_pre_EstadoSolicitud.TipoEstadoSolicitudID") {
      params = new URLSearchParams({
        search,
        order: "police_formulario_deposito.createdAt desc",
        getTotal: "true",
      });
    } else {
      params = new URLSearchParams({
        search,
        order: "exp_pre_EfectoDeposito.FechaCreacion desc",
        getTotal: "true",
      });
    }
    return params.toString();
  };

  const getTotals = async () => {
    const totals = await Promise.all(
      typeStates.value.map(async (tipo) => {
        const { data } = await rest.get(
          `${baseUrl}/formulario-deposito?${buildSearchParams("exp_pre_EstadoSolicitud.TipoEstadoSolicitudID", tipo.TipoEstadoSolicitudID)}`
        );
        return {
          ...tipo,
          total: +data.data[0].total || 0,
        };
      })
    );
    totalsTypesStates.value = totals;
  };

  const fetchEstadisticasByID = async (id) => {
    if (!loadingItems.value.includes(id)) {
      loadingItems.value.push(id);
    }
    try {
      const { data } = await rest.get(
        `${baseUrl}/formulario-deposito?${buildSearchParams("exp_pre_EstadoSolicitud.TipoEstadoSolicitudID", id)}`
      );

      const index = totalsTypesStates.value.findIndex((t) => t.TipoEstadoSolicitudID === id);
      if (index !== -1) {
        totalsTypesStates.value[index].total = +data.data[0]?.total || 0;
      }
    } catch (error) {
      console.log("error al pedir datos", error);
    } finally {
      loadingItems.value = loadingItems.value.filter((item) => item !== id);
    }
  };

  const isLoadingItem = (id) => {
    return !!loadingItems.value.find((item) => item === id);
  };

  const fetchEstadisticas = async () => {
    try {
      loadingJudicial.value = true;
      store.dispatch("siis/setCategoriasDeposito");
      const { data } = await rest.get(`${baseUrl}/tipo-estado-solicitud`);
      typeStates.value = data.data;
      await getTotals();
      await buildStats();
    } catch (e) {
      console.error("Error al obtener Estadísticas:", e);
    } finally {
      loadingJudicial.value = false;
    }
  };

  return {
    fetchEstadisticas,
    fetchEstadisticasByID,
    loadingJudicial,
    typeStates,
    totalsTypesStates,
    categoriesLabels,
    seriesData,
    isLoadingItem,
  };
});
